import { HttpClientModule } from '@angular/common/http';
import { CommonModule, PathLocationStrategy, Location } from '@angular/common';
import { UpaService } from '../../../common/services/upa.service';
import { CustomTimmingsService } from '../../../common/services/custom-timming-service.service';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MediaPictureModule } from '@shopping-angular-components/media-picture';
import { EvaCardsWrapperModule } from 'projects/common/components/eva-cards-wrapper/eva-cards-wrapper.module';
import { HeaderWrapperModule } from 'projects/common/components/header-wrapper/header-wrapper.module';
import { InterLinkModule } from 'projects/common/components/interlinks/inter-link.module';
import { OffersModule } from 'projects/common/components/offers/offers.module';
import { ParagraphsRecursiveComponent } from 'projects/common/components/paragraphs/paragraphs-recursive.component';
import { ParagraphsComponent } from 'projects/common/components/paragraphs/paragraphs.component';
import { TextAndImageModule } from 'projects/common/components/text-and-image/text-and-image.module';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { MessagesService } from 'projects/common/services/messages.service';
import { BannerBackgroundComponent } from '../../../common/components/banner-background/banner-background.component';
import { BannerIconComponent } from '../../../common/components/banner-icon/banner-icon.component';
import { CovidModule } from '../../../common/components/covid/covid.module';
import { EvaCardModule } from '../../../common/components/eva-card/eva-card.module';
import { GridModule } from '../../../common/components/grid/grid.module';
import { IconsModule } from '../../../common/components/icons/icons.module';
import { SboxModule } from '../../../common/components/sbox/sbox.module';
import { SliderModule } from '../../../common/components/slider/slider.module';
import { TagTextModule } from '../../../common/components/tag-text/tag-text.module';
import { TextListModule } from '../../../common/components/text-list/text-list.module';
import { TextModule } from '../../../common/components/text/text.module';
import { EvaButtonModule } from '../../../common/components/eva-button/eva-button.module';
import { AppComponent } from './app.component';
import { CustomTranslateLoader } from './custom/custom-translate-loader';
import { MulticurrencyComponent } from 'projects/common/components/multicurrency/multicurrency.component';
import { FormsModule } from '@angular/forms';
import { FilterModule } from 'projects/common/components/filter/filter.module';
import { ModalModule, ModalService } from '@shopping-angular-components/modal';
import { RouterModule, UrlSerializer } from '@angular/router';
import { LoaderModule } from '@shopping-angular-components/loader';
import { SubscriptionActivationComponent } from '../../../common/components/subscription-activation/subscription-activation.component';
import { SubscriptionFormComponent } from '../../../common/components/subscription-form/subscription-form.component';
import { EmptyStateModule } from '../../../common/components/empty-state/empty-state.module';
import { GroupedInterlinksModule } from '../../../common/components/grouped-interlinks/grouped-interlinks.module';
import { DraperBannerWrapperModule } from '../../../common/components/draper-banner-wrapper/draper-banner-wrapper.module';
import { InputTextFilterComponent } from '../../../common/components/input-filter/input-text-filter.component';
import { DocumentViewerComponent } from '../../../common/components/document-viewer/document-viewer.component';
import { FrequentlyAskedQuestionComponent } from '../../../common/components/frequently-asked-question/frequently-asked-question.component';
import { CustomUrlSerializer } from './custom/custom-url-serializer';
import { EvaTagModule } from 'projects/common/components/eva-tag/eva-tag.module';
import { FiltersService } from 'projects/common/services/filters.service';
import { OffersFiltersModule } from 'projects/common/components/offers-filters/offers-filters.module';
import { FlexSafeStayBannerWrapperModule } from 'projects/common/components/flex-safe-stay-banner-wrapper/flex-safe-stay-banner-wrapper.module';
import { VideoPlayerModule } from 'projects/common/components/video-player/video-player.module';
import { PictureModule } from 'projects/common/components/picture/picture.module';
import { MultiBannerModule } from 'projects/common/components/multi-banner/multi-banner.module';
import { PreHeadingModule } from '../../../common/components/pre-heading/pre-heading.module';
import { AdsBannersModule } from '../../../common/components/ads-banners/ads-banners.module';
import { AdsRegularBannersComponent } from '../../../common/components/ads-regular-banners/ads-regular-banners.component';
import { BreadcrumbModule } from 'projects/common/components/breadcrumb/breadcrumb.module';
import { EvaDropdownModule } from 'projects/common/components/eva-dropdown/eva-dropdown.module';
import { GlobalErrorHandler } from 'projects/common/services/global-error-handler';
import { ReviewsSummaryModule } from 'projects/common/components/reviews-summary/reviews-summary.module';
import { GroupedModulesComponent } from '../../../common/components/grouped-modules/grouped-modules.component';
import { EvaTabsModule } from '@shopping-angular-components/eva-tabs';
import { MetaComponent } from './meta-component/meta-component.component';
import { MediaPictureGalleryModule } from '@shopping-angular-components/media-picture-gallery';
import { PictureListModule } from 'projects/common/components/picture-list/picture-list.module';
import { DescriptionDetailedModule } from 'projects/common/components/description-detailed/description-detailed.module';
import { EvaMessageModule } from 'projects/common/components/eva-message/eva-message.module';
import { FareSuggestionChartContainerModule } from 'projects/common/components/fare-suggestion-chart-container/fare-suggestion-chart-container.module';
import { SealsBannerModule } from 'projects/common/components/seals-banner/seals-banner.module';
import { RoomTypeModalContentModule } from 'projects/common/components/modal/room-type-modal-content/room-type-modal-content.module';
import { HotelImagesGalleryModule } from "../../../common/components/hotel-images-gallery/hotel-images-gallery.module";
import { MapModuleModule } from "../../../common/components/map-module/map-module.module";
import { IframeEmbedComponent } from '../../../common/components/iframe-embed/iframe-embed.component';
import { MainTitleModule } from '../../../common/components/main-title/main-title.module';
import { WizumenModule } from 'projects/common/components/wizumen/wizumen.module';
import { UserFavoritesModule } from 'projects/common/components/user-favorites/user-favorites.module';
import { TableModuleModule } from "../../../common/components/table-module/table-module.module";
import { FormModule } from 'projects/common/components/form/form.module';
import { ChatAIModule } from 'projects/common/components/chatAI/chat-AI.module';
import { TextBannerModule } from "../../../common/components/text-banner/text-banner.module";
import { SkeletonModule } from 'projects/common/components/skeleton/skeleton.module';
import { ReelsModule } from 'projects/common/components/reels/reels.module';
import { UserLandingsModule } from 'projects/common/components/user-landings/user-landings.module';
import { UserLandingsV2Module } from 'projects/common/components/user-landings-v2/user-landings-v2.module';
import { ConfirmButtonsComponent } from 'projects/common/components/confirm-buttons/confirm-buttons.component';
import { PaymentPromosModule } from 'projects/common/components/payment-promos/payment-promos.module';
import { UserRecentActivityModule } from 'projects/common/components/user-recent-activity/user-recent-activity.module';
import { ItineraryModule } from 'projects/common/components/itinerary/itinerary.module';
import { InfoMetadataComponent } from './meta-component/info-metadata/info-metadata.component';
import { InfoMetadataModalComponent } from './meta-component/info-metadata/info-metadata-modal.component';
import { FlightOffersModule } from 'projects/common/components/flights/flight-offers.module';
import { PriceAlertsModule } from 'projects/common/components/price-alerts/price-alerts.module';
import { CommonModalContentComponent } from 'projects/common/components/modal/common-modal-content/common-modal-content.component';
import { EventDispatcherModule } from 'projects/common/components/event-dispatcher/event-dispatcher.module';
import { EventDispatcherService } from 'projects/common/services/event-dispatcher.service';
import { LandingHistoryModule } from 'projects/common/components/landing-history/landing-history.module';
import { TextLayoutModule } from 'projects/common/components/text-layout/text-layout.module';
import { GridContainerComponent } from 'projects/common/components/grid-container/grid-container.component';
import { SubnavModuleModule } from 'projects/common/components/eva-subnav/eva-subnav.module';

export function TranslateLoaderFactory(landingModelService: LandingModelService) {
  return new CustomTranslateLoader(landingModelService);
}

const _orig_prepareExternalUrl = PathLocationStrategy.prototype.prepareExternalUrl;

PathLocationStrategy.prototype.prepareExternalUrl = function (internal) {
  return _orig_prepareExternalUrl.call(this, internal);
};

Location.stripTrailingSlash = url => url;

@NgModule({
  declarations: [
    AppComponent,
    MetaComponent,
    InfoMetadataComponent,
    InfoMetadataModalComponent,
    ParagraphsComponent,
    BannerBackgroundComponent,
    BannerIconComponent,
    ParagraphsRecursiveComponent,
    MulticurrencyComponent,
    InputTextFilterComponent,
    SubscriptionActivationComponent,
    SubscriptionFormComponent,
    DocumentViewerComponent,
    FrequentlyAskedQuestionComponent,
    AdsRegularBannersComponent,
    GroupedModulesComponent,
    IframeEmbedComponent,
    ConfirmButtonsComponent,
    CommonModalContentComponent,
    GridContainerComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [LandingModelService]
      }
    }),
    SliderModule,
    GridModule,
    IconsModule,
    EvaCardModule,
    HeaderWrapperModule,
    EvaCardsWrapperModule,
    MediaPictureModule,
    TagTextModule,
    TextModule,
    EvaButtonModule,
    CovidModule,
    InterLinkModule,
    LandingHistoryModule,
    OffersModule,
    SboxModule,
    FareSuggestionChartContainerModule,
    TextListModule,
    TextModule,
    TextAndImageModule,
    EmptyStateModule,
    GroupedInterlinksModule,
    FilterModule,
    DraperBannerWrapperModule,
    RouterModule.forRoot([{
      path: '**',
      component: AppComponent,
      pathMatch: 'full'
    }], {}),
    LoaderModule,
    GroupedInterlinksModule,
    EvaTagModule,
    OffersFiltersModule,
    FlexSafeStayBannerWrapperModule,
    VideoPlayerModule,
    PictureModule,
    ModalModule,
    MultiBannerModule,
    PreHeadingModule,
    AdsBannersModule,
    BreadcrumbModule,
    EvaDropdownModule,
    ReviewsSummaryModule,
    EvaDropdownModule,
    EvaTabsModule,
    MediaPictureGalleryModule,
    PictureListModule,
    DescriptionDetailedModule,
    EvaMessageModule,
    SealsBannerModule,
    RoomTypeModalContentModule,
    MapModuleModule,
    HotelImagesGalleryModule,
    MainTitleModule,
    WizumenModule,
    UserFavoritesModule,
    TableModuleModule,
    FormModule,
    ChatAIModule,
    TextBannerModule,
    SkeletonModule,
    ReelsModule,
    UserLandingsModule,
    UserLandingsV2Module,
    PaymentPromosModule,
    UserRecentActivityModule,
    ItineraryModule,
    FlightOffersModule,
    PriceAlertsModule,
    EventDispatcherModule,
    TextLayoutModule,
    SubnavModuleModule
],
  providers: [
    LandingModelService,
    MessagesService,
    ModalService,
    UpaService,
    CustomTimmingsService,
    FiltersService,
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    EventDispatcherService
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
